export { default as TanquesListar } from './Listar'
// export { default as TanqueCrear } from './Crear'
// export { default as TanqueVer } from  './Ver'
